export default "__VITE_ASSET__DgIjv2bT__"